import { useEffect } from 'react'
import axios from './../../utils/axios'
import { CancelToken } from 'axios'
import { intl } from './../../utils/intl'
import { SALES_EMAIL } from './../../constants'

const t = (id) => intl.formatMessage({ id })

const USER_TITLES = {
  'Asset Manager': t('ViewProfile.assetManager'),
  'Leasing Representative': t('ViewProfile.leasingRepresentative'),
  'Property Manager': t('ViewProfile.propertyManager'),
  'Billing Specialist': t('ViewProfile.billingSpecialist'),
  'Renewal Agent': t('ViewProfile.renewalAgent'),
  'Property Manager Assistant': t('ViewProfile.propertyManagerAssistant'),
  'Leasing Agent': t('ViewProfile.leasingAgent'),
  'Construction Manager': t('ViewProfile.constructionManager')
}

const usePropertyContact = (company, property, setContact) => {
  useEffect(() => {
    let source = CancelToken.source()
    const fetchProperty = async () => {
      try {
        const result = await axios.get(`/public/properties/${encodeURIComponent(company)}/${encodeURIComponent(property)}`, { cancelToken: source.token })
        if (result.data.errors) return
        const _contacts = result.data.record.property_contacts
        let returnContact
        // if property contact not found, search company contacts
        // if property contact found, search for Leasing Representative
        if (!_contacts || _contacts.length === 0) {
          returnContact = await getCompanyContact()
        } else {
          // fetch Leasing Representative contact email
          returnContact = await fetchUserTypes(_contacts)
          if (!returnContact) {
            // if Leasing Representative not found, search company contacts
            returnContact = await getCompanyContact()
          }
        }
        setContact(returnContact)
      } catch (e) {
        console.warn('Unable to fetch property contacts', e)
      }
    }

    const fetchUserTypes = async (_contacts) => {
      try {
        let contactEmail = await Promise.all(_contacts.map(async (contact) => {
          if (!contact.email) return null
          const result = await axios.get(`/public/users/${contact.email}`, { cancelToken: source.token })
          if (!result.data.record) return null
          if (result.data.record.companyTitle === USER_TITLES['Leasing Representative']) {
            return contact.email
          }
        }))
        return contactEmail.find(_ => _)
      } catch (e) {
        console.warn('Unable to fetch user types')
      }
    }

    const getCompanyContact = async () => {
      try {
        const result = await axios.get(`/public/companies/${encodeURIComponent(company)}`, { cancelToken: source.token })
        if (result.data.errors) return
        // Select contact email as per the following priority
        // If property contact is not found, check
        // 1. For Company level Leasing Management Email
        // 2. Company level contact email
        // 3. If none exist, default to sales@idplans.com
        const companyContacts = result.data.record.contacts
        if (companyContacts && companyContacts.leasing_management_email) {
          return companyContacts.leasing_management_email
        } else if (result.data.record.contactemail) {
          return result.data.record.contactemail
        } else return SALES_EMAIL
      } catch (e) {
        console.warn('Unable to get company info', e)
      }
    }

    if (!company || !property) return null
    fetchProperty()

    return () => {
      source.cancel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company, property])
}

export { usePropertyContact }